import * as React from "react"
import { View, Text, FlatList, TouchableOpacity } from "react-native"
import { isEmptyString } from "../../utils/utils";
import { Icons } from "../../config/icons";
import type { KiaRequest } from "../../models/kia-request/kia-request"
import { KiaIcon } from "../icon/icon";
import { LinkText } from "../link-text/link-text";

import * as styles from "./request-list.style";
import { ThatDot } from "../that-dot/that-dot";
import { spacing } from "../../theme";
import { TouchableKiaIcon } from "../icon/touchable-icon";
import { observer } from 'mobx-react-lite';
import { useNavigation } from '@react-navigation/native';

const summaryIcon = (request: KiaRequest):string => {
    if(request.requestParams.jobs){
        if(request.requestParams.jobs.indexOf("summary")!=-1){
            if(!isEmptyString(request.response.summary))
                return Icons.summary.success;
            else
                return Icons.summary.processing;
        }
    }
    return "";
}

const qaIcon = (request: KiaRequest):string => {
    if(request.requestParams.jobs){
        if(request.requestParams.jobs.indexOf("qa")!=-1 || request.requestParams.jobs.indexOf("gen_qa")!=-1){
            if(request.response.qa.length>0)
                return Icons.qa.success;
            else
                return Icons.qa.processing;
        }
    }
    return "";
}

function renderProcessedItem(request: KiaRequest, unprocessed:boolean=false) {
    const iconForSummary = summaryIcon(request);
    const iconForQA = qaIcon(request);
    const navigation = useNavigation();
    const requestDetailScreen = () => navigation.navigate('details', { id: request.id });
    return(
        <TouchableOpacity onPress={requestDetailScreen} style={styles.componentView}>
            <View style={styles.listItemView}>
                <Text numberOfLines={1} style={styles.titleText}>{unprocessed? "Unprocessed" :request.response.title}</Text>
                <View style={styles.timeAgoView}>
                    <TouchableKiaIcon onPress={() => request.toggleBookmark()} iconProps={{src:request.bookmarked ? Icons.bookmarks.yes : Icons.bookmarks.no,marginRight:spacing[2],size:'tiny'}} />
                    <KiaIcon src={request.isGlobal ? Icons.global : Icons.private} size='tiny' marginRight={spacing[2]} />                
                    <KiaIcon src={Icons.time} size='tiny' />
                    <Text style={styles.timeAgoText}>{ request.createdDate }</Text>
                </View>
            </View>    
            {
                !isEmptyString(request.requestParams.url) &&
                <View style={styles.labelView}>
                    <Text style={styles.labelText}>URL</Text>
                    <LinkText text={request.requestParams.url} url={request.requestParams.url} />
                </View>
            }
            {
                !isEmptyString(request.response.longText) &&
                <View style={styles.labelView}>
                    <Text style={styles.labelText}>Article</Text>
                    <Text numberOfLines={3}>{request.response.longText}</Text>
                </View>
            }
            <View style={styles.listItemView}>                                
                {
                    !isEmptyString(iconForSummary) &&
                    <View style={styles.iconView}>
                        <KiaIcon src={iconForSummary} size='medium' />
                        <Text style={styles.iconLabel}>Summary</Text>
                    </View>
                    
                }
                {!isEmptyString(iconForQA) && !isEmptyString(iconForSummary) && <ThatDot />}
                {
                    !isEmptyString(iconForQA) &&
                    <View style={styles.iconView}>
                        <KiaIcon src={iconForQA} size='medium' />
                        <Text style={styles.iconLabel}>Question Answer</Text>
                    </View>
                }
                
            </View>
        </TouchableOpacity>
    )
}

const onRequestListRefresh = () => {
    console.log("on refresh");
}

export const RequestListItem = observer(function RequestListItem(props:any){
    const request: KiaRequest = props.item;
    return renderProcessedItem(request, request.response.id==0);
});

export const RequestList = observer(function RequestList(props: any){    
    return(
        <FlatList 
            data = {props.data}
            renderItem={({item}) => <RequestListItem item={item} />}
            onEndReached={props.onRequestListEndReached}
            onEndReachedThreshold={5}
            onRefresh={onRequestListRefresh}
            refreshing={false}
        />
    )
});